<template>
  <d-container fluid class="main-content-container p-4">
    <d-modal v-if="modalVisible" size="lg" @close="onModalClose">
      <d-modal-header>
        <d-modal-title>Détails du virement</d-modal-title>
      </d-modal-header>
      <d-modal-body>
        <div class="text-center mb-3">
          <d-badge outline pill :theme="badge">{{ status_fr }}</d-badge>
        </div>
        <d-form-row>
          <d-col class="pr-3 border-right">
            <c-input container-class="mb-3" label="Code unique" :value="unique_code_computed" disabled/>
            <c-input type="price" currency="XAF" container-class="mb-3" label="Montant" :value="amount" disabled/>
            <c-input type="textarea" container-class="mb-3 mt-3" label="Type de recette" :value="recipe_type" disabled/>
            <c-input type="datetime" container-class="mb-3" label="Payé le" :value="paid_at" disabled/>
            <c-input type="datetime" container-class="mb-3" label="Utilisé le" :value="archived_at" disabled/>
          </d-col>
          <d-col class="ml-2">
            <c-input type="datetime" container-class="mb-3" label="Importé le" :value="created_at" disabled/>
            <c-input type="datetime" container-class="mb-3" label="Confirmé le" :value="confirmed_at" disabled/>
            <c-input container-class="mb-3" label="Statut de paiement" :value="payment_status" disabled/>
            <c-input type="textarea" container-class="mb-3 mt-3" label="Message"
                     v-model="message" :state="message_state" :disabled="!is_editable">
              Veuillez saisir un message
            </c-input>
            <b-form-group v-if="!is_editable">
              <label class="font-weight-bold mb-0">Pièce jointe</label>
              <d-input-group>
                <d-input-group-addon class="flex-fill" prepend>
                  <c-input class="flex-fill" :value="attachment" disabled/>
                </d-input-group-addon>
                <d-input-group-addon append>
                  <d-link class="btn btn-info" :href="attachment" target="_blank" :disabled="!has_attachment">
                    <i class="fa fa-external-link-alt mr-1"></i> Ouvrir
                  </d-link>
                </d-input-group-addon>
              </d-input-group>
            </b-form-group>
            <c-input v-else type="file" container-class="mb-3" label="Pièce justificative"
                     v-model="attachment_file" :state="attachment_state">
              Veuillez charger une pièce justificative
            </c-input>
          </d-col>
        </d-form-row>
        <div>
          <!-- COLLAPSE-->
          <div class="text-center mt-2">
            <b-link v-b-toggle.extra-data-collapsible>
              <i class="fas fa-caret-down mr-2 "></i> Voir plus de détails
            </b-link>
          </div>

          <!-- Element to collapse -->
          <b-collapse id="extra-data-collapsible">
            <c-table class="px-0 mt-3" :table-data="parameters" :fields="extraDataFields" :per-page="5"
                     no-top-pagination>
              <p class="text-center" slot="empty">Aucune donnée supplémentaire.</p>
            </c-table>
          </b-collapse>
        </div>
      </d-modal-body>
      <d-modal-footer class="justify-content-center">
        <c-button-spinner v-if="is_editable" class="mr-2" variant="success" :fetching="fetchingFormSubmit"
                          @click="onFormSubmit">
          <template slot="icon">
            <i class="fa fa-check"></i>
          </template>
          Confirmer le virement
        </c-button-spinner>
        <b-button variant="secondary" class="ml-2" @click="onModalClose">
          <i class="fa fa-times"></i> Fermer
        </b-button>
      </d-modal-footer>
    </d-modal>
    <d-modal v-if="modalCreateVisible" @close="onCreateModalClose">
      <d-modal-header>
        <d-modal-title>Rapatrier un paiement</d-modal-title>
      </d-modal-header>
      <d-modal-body>
        <p class="text-danger text-center" v-if="hasError">{{ errorMessage }}</p>
        <d-form-row>
          <d-col>
            <c-input type="select" label="Application émettrice" v-model="app_code" :state="app_code_state">
              <template slot="first">
                <option value="RNF">RNF (Registre National des Fournisseurs)</option>
                <option value="DGI">DGI (Direction Générale des Impôts)</option>
                <option value="DGD">DGD (Direction Générale des Douanes)</option>
              </template>
              Veuillez sélectionner l'application émettrice
            </c-input>
            <c-input container-class="mb-3" label="Code unique" placeholder="Ex: X12Y0123456789"
                     v-model="unique_code" :state="unique_code_state">
              Veuillez saisir un code unique
            </c-input>
          </d-col>
        </d-form-row>
      </d-modal-body>
      <d-modal-footer class="justify-content-center">
        <c-button-spinner class="mr-2" variant="success" :fetching="fetchingCreateSubmit" @click="onCreateFormSubmit">
          <template slot="icon">
            <i class="fa fa-search"></i>
          </template>
          Rechercher
        </c-button-spinner>
        <b-button variant="secondary" class="ml-2" @click="onCreateModalClose">
          <i class="fa fa-times"></i> Fermer
        </b-button>
      </d-modal-footer>
    </d-modal>

    <div>
      <!-- COLLAPSE-->
      <b-button v-b-toggle.collapse-2 class="m-1 greenbutton">
        <i class="fas fa-filter mr-2 "></i> Recherche avancée
      </b-button>

      <!-- Element to collapse -->
      <b-collapse id="collapse-2" class="mb-4">
        <d-card class="card-small">
          <d-card-body class="px-4 pb-0">
            <b-row>
              <d-input-group class="justify-content-center">
                <c-input label="Du" type="date" class="mr-5" v-model="startDate"/>
                <c-input label="Au" type="date" class="mr-5" v-model="endDate"/>
                <c-input label="Mot clé de recherche" class="mr-5" placeholder="Rechercher..." v-model="search"/>
                <c-input type="select" label="Rechercher par statut" class="mr-5" :options="status_options"
                         v-model="searchStatus">
                  <template slot="first">
                    <option :value="null">Sélectionnez un statut</option>
                  </template>
                </c-input>
              </d-input-group>
            </b-row>
            <b-row class="justify-content-center">
              <c-button-spinner class="inline-btn ml-1 mb-3" variant="primary" :fetching="fetchingSearch"
                                @click="onSearchSubmit">
                <template slot="icon">
                  <i class="fa fa-search"></i>
                </template>
                Rechercher
              </c-button-spinner>
            </b-row>
          </d-card-body>
        </d-card>
      </b-collapse>
    </div>

    <d-card class="card-small">
      <d-card-header v-if="has_right" class="pb-0">
        <d-input-group class="justify-content-center">
          <d-button class="inline-btn" @click="modalCreateVisible = true">
            <i class="fa fa-download mr-1"></i> Rapatrier un paiement
          </d-button>
        </d-input-group>
      </d-card-header>
      <d-card-body class="pt-3">
        <c-table :fetching="fetchingData" :table-data="filteredData" :fields="fields" :actions="actions" :per-page="50">
          <p class="text-center" slot="empty">Aucun virement trouvé.</p>
        </c-table>
      </d-card-body>
    </d-card>
  </d-container>
</template>

<script>
import { Api, formatAmount, Regex, Toast, truncate } from "@/helpers"

export default {
  title: "Virements Trésor Pay",
  data() {
    return {
      search: "",
      fetchingSearch: false,
      startDate: "",
      endDate: "",
      searchStatus: null,

      fetchingData: false,
      data: [],

      //table header
      fields: [
        {
          key: "app_code",
          label: "Émetteur",
          sortable: true,
        },
        {
          key: "unique_code",
          label: "Code unique",
          sortable: true,
        },
        {
          key: "recipe_type_pretty",
          label: "Type de recette",
          sortable: true,
        },
        {
          key: "amount_pretty",
          label: "Montant",
          sortable: true,
        },
        {
          key: "operator",
          label: "Opérateur",
          sortable: true,
        },
        {
          key: "status",
          label: "Statut",
          sortable: true,
        },
        {
          key: "paid_at_pretty",
          label: "Payé le",
          sortable: true,
        },
        {
          key: "confirmed_at_pretty",
          label: "Confirmé le",
          sortable: true,
        },
        {
          key: "actions",
          label: "Actions",
        },
      ],

      extraDataFields: [
        {
          key: "parameterLabelFr",
          label: "Propriété",
        },
        {
          key: "parameterValue",
          label: "Valeur",
        },
      ],

      actions: [
        {
          type: "white",
          icon: "fa fa-ellipsis-h",
          title: "Détails du virement",
          handler: this.onItemSelect,
        },
      ],

      modalVisible: false,

      selectedItem: null,

      status_options: [],

      message: "",
      attachment_file: "",

      submitted: false,
      fetchingFormSubmit: false,

      modalCreateVisible: false,
      app_code: "RNF",
      unique_code: "",
      submittedCreate: false,
      fetchingCreateSubmit: false,
    }
  },
  watch: {
    service(value) {
      if (value) {
        this.fetchingBankAccounts = true
        Api.get("/service/bank_accounts", { service_id: this.service })
          .then(res => this.bankAccounts = res.data.bank_accounts.map(bank_account => ({
            value: bank_account.id,
            text: bank_account.name + ` (${bank_account.bank.name})`,
          })))
          .catch(err => this.error = err)
          .then(() => this.fetchingBankAccounts = false)
      }
    },
  },
  computed: {
    filteredData() {
      const search = this.search.toLowerCase()
      return this.data.filter(item => {
        return (!this.searchStatus || this.searchStatus === item.processing_status)
          && (
            item.payment_id.toLowerCase()
              .includes(search)
            || item.app_code.toLowerCase()
              .includes(search)
            || item.unique_code.toLowerCase()
              .includes(search)
            || item.recipe_type.toLowerCase()
              .includes(search)
            || item.recipe_type_id.toLowerCase()
              .includes(search)
            || item.psp_transaction_ref.toLowerCase()
              .includes(search)
          )
      })
    },
    itemSelected() {
      return !!this.selectedItem
    },
    has_right() {
      return this.auth.isTresorPayManager() || this.auth.isOpManager()
    },
    is_editable() {
      return this.has_right && this.itemSelected && this.selectedItem.processing_status !== "PAID"
    },
    status_fr() {
      return this.itemSelected ? this.selectedItem.status : ""
    },
    badge() {
      return this.itemSelected ? this.selectedItem.badge : ""
    },
    app_code_computed() {
      return this.itemSelected ? this.selectedItem.app_code : ""
    },
    unique_code_computed() {
      return this.itemSelected ? this.selectedItem.unique_code : ""
    },
    amount() {
      return this.itemSelected ? this.selectedItem.amount : ""
    },
    recipe_type() {
      return this.itemSelected ? this.selectedItem.recipe_type : ""
    },
    recipe_type_id() {
      return this.itemSelected ? this.selectedItem.recipe_type_id : ""
    },
    payment_id() {
      return this.itemSelected ? this.selectedItem.payment_id : ""
    },
    archived_at() {
      return this.itemSelected ? this.selectedItem.archived_at : ""
    },
    operator() {
      return this.itemSelected ? this.selectedItem.operator : ""
    },
    payment_status() {
      return this.itemSelected ? this.selectedItem.payment_status : ""
    },
    psp_transaction_ref() {
      return this.itemSelected ? this.selectedItem.psp_transaction_ref : ""
    },
    paid_at() {
      return this.itemSelected ? this.selectedItem.paid_at : ""
    },
    parameters() {
      return this.itemSelected ? this.selectedItem.parameters : []
    },
    created_at() {
      return this.itemSelected ? this.selectedItem.created_at : ""
    },
    confirmed_at() {
      return this.itemSelected ? this.selectedItem.confirmed_at : ""
    },
    has_attachment() {
      return this.itemSelected ? !!this.selectedItem.attachment : false
    },
    attachment() {
      return this.itemSelected
        ? this.selectedItem.attachment
          ? this.selectedItem.attachment : "-- Aucune pièce jointe --"
        : ""
    },

    message_state() {
      return !this.submitted || Regex.isNotBlank(this.message)
    },
    attachment_state() {
      return !this.submitted || Regex.isNotEmpty(this.attachment_file)
    },

    app_code_state() {
      return !this.submittedCreate || this.app_code
    },
    unique_code_state() {
      return !this.submittedCreate || Regex.isNotBlank(this.unique_code)
    },
  },
  created() {
    this.fetchingData = true

    Api.get("/tresorpay/payment/states")
      .then(res => this.status_options = res.data.payment_states)
      .catch(err => this.error = err)
      .then(() => null)

    Api.get("/tresorpay/payment/list")
      .then(res => {
        const data = res.data.payments
        if (data) {
          this.data = data.map(this.mapItem)
        } else {
          Toast.info("Aucun virement trouvé")
        }
      })
      .catch(err => this.error = err)
      .then(() => this.fetchingData = false)
  },
  methods: {
    mapItem(item) {
      return {
        ...item,
        recipe_type_pretty: truncate(item.recipe_type, 30),
        amount_pretty: formatAmount(item.amount),
        status: item.processing_status_fr,
        statusVariant: item.badge,
        paid_at_pretty: item.paid_at ? item.paid_at.replace(" ", "\n") : "---",
        confirmed_at_pretty: item.confirmed_at ? item.confirmed_at.replace(" ", "\n") : "---",
      }
    },
    onItemSelect(item) {
      this.selectedItem = item
      this.modalVisible = true
      this.message = item.message
    },
    clearFields() {
      this.message = ""
      this.attachment_file = ""
    },
    onModalClose() {
      this.modalVisible = false
      this.submitted = false
      this.selectedItem = null
      this.error = null
      this.clearFields()
    },
    isFormValid() {
      return this.message_state && this.attachment_state
    },
    onFormSubmit() {
      this.submitted = true
      if (!this.isFormValid()) return

      const {app_code, unique_code, amount} = this.selectedItem

      const description = `le virement de ${formatAmount(amount)} XAF pour le code unique ${app_code}/${unique_code}`
      const ans = prompt(`Veuillez saisir "CONFIRMER" pour confirmer ${description}.`)
      if (ans !== "CONFIRMER") return

      this.fetchingFormSubmit = true
      Api.postFormData("/tresorpay/payment/confirm", {
        app_code, unique_code,
        message: this.message,
        attachment: this.attachment_file,
      })
        .then(res => {
          const payment = this.mapItem(res.data.payment)
          this.data.unshift(payment)

          this.onModalClose()

          Toast.success(`Le virement a été confirmé avec succès !`)
        })
        .catch(err => this.error = err)
        .then(() => this.fetchingFormSubmit = false)
    },

    clearCreateFields() {
      this.app_code = "RNF"
      this.unique_code = ""
    },
    onCreateModalClose() {
      this.modalCreateVisible = false
      this.submittedCreate = false
      this.error = null
      this.clearCreateFields()
    },
    isCreateFormValid() {
      return this.app_code_state && this.unique_code_state
    },
    onCreateFormSubmit() {
      this.submittedCreate = true
      if (!this.isCreateFormValid()) return

      this.fetchingCreateSubmit = true
      Api.get("/tresorpay/payment/import", {
        app_code: this.app_code,
        unique_code: this.unique_code,
      })
        .then(res => {
          const payment = this.mapItem(res.data.payment)

          this.onCreateModalClose()
          this.onItemSelect(payment)
        })
        .catch(err => this.error = err)
        .then(() => this.fetchingCreateSubmit = false)
    },

    onSearchSubmit() {
      this.data = []
      this.fetchingSearch = true
      Api.get("/tresorpay/payment/find", {
        search: this.search,
        start_date: this.startDate,
        end_date: this.endDate,
        status: this.searchStatus,
      })
        .then((res) => {
          const data = res.data.payments
          if (data) {
            this.data = data.map(this.mapItem)
          } else {
            Toast.info("Aucun virement trouvé")
          }
        })
        .catch(err => this.error = err)
        .then(() => this.fetchingSearch = false)
    },
  },
}
</script>
